import { useRouter } from 'next/router';
import { setDigitalData } from './audiencies-datalayer';
import { useEffect } from 'react';

export default function AudienciesAmp(props) {
    useEffect(() => {
        if (typeof window === 'object') {
            if (window.s) {
                window.s.pageType = undefined;
            }
        }
    }, []);
    const router = useRouter();
    const digitalData = setDigitalData({
        ...props,
        router
    });
    const entorn = process.env.ENTORN;
    const account = entorn === 'aws_dev' || entorn === 'aws_test' ? 'UA-1972918-47' : 'UA-1972918-46';
    const reportsuite = entorn === 'aws_dev' || entorn === 'aws_test' ? 'caccma' : 'caproccma';
    const externalReferrer = (() => {
        const queryParam = router.query.__twitter_impression;
        return queryParam && queryParam !== '' ? 't.co' : '${externalReferrer}';
    })();

    return (
        <>
            <amp-analytics type='adobeanalytics_nativeConfig'>
                <script
                    type='application/json'
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            requests: {
                                base: 'https://${host}',
                                iframeMessage:
                                    '${base}/amp/audienciesadobe.html?account=${accounts}&pageURL=${ampdocUrl}&ref=' +
                                    externalReferrer +
                                    '&pageName=' +
                                    digitalData.page.actualPageName +
                                    '&evar6=' +
                                    digitalData.page.URL +
                                    '&evar1=' +
                                    digitalData.page.web +
                                    '&evar2=' +
                                    digitalData.page.seccio +
                                    '&evar3=' +
                                    digitalData.page.subseccio +
                                    '&evar4=' +
                                    digitalData.page.subseccioNivell1 +
                                    '&evar5=' +
                                    digitalData.page.subseccioNivell2 +
                                    '&evar7=' +
                                    digitalData.page.tipusPagina +
                                    ' (AMP)' +
                                    '&evar8=' +
                                    digitalData.page.programaWeb +
                                    '&evar9=' +
                                    digitalData.page.areaTematicaWeb +
                                    '&evar14=' +
                                    digitalData.page.idDeliverty +
                                    '&evar19=' +
                                    digitalData.page.dataEmissio +
                                    '&evar25=' +
                                    digitalData.page.productorContingut +
                                    '&evar40=' +
                                    digitalData.page.cercadorKW +
                                    '&evar41=' +
                                    digitalData.page.cercadorResultats +
                                    '&evar69=' +
                                    digitalData.page.formatva +
                                    '&evar83=' +
                                    digitalData.page.campanyesInternes +
                                    '&evar84=' +
                                    digitalData.page.lectorPantalla +
                                    '&evar86=' +
                                    digitalData.page.autor +
                                    '&evar89=' +
                                    digitalData.page.consent +
                                    '&l1=' +
                                    digitalData.page.temes
                            },
                            vars: {
                                host: 'embed.3cat.cat',
                                accounts: reportsuite
                            }
                        })
                    }}
                />
            </amp-analytics>

            <amp-analytics type='comscore' id='comscore'>
                <script
                    type='application/json'
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            vars: {
                                c2: '11548294'
                            },
                            extraUrlParams: {
                                comscorekw: 'amp'
                            }
                        })
                    }}
                />
            </amp-analytics>

            <amp-analytics type='googleanalytics' id='google'>
                <script
                    type='application/json'
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            vars: {
                                account: account
                            },
                            triggers: {
                                trackPageview: {
                                    on: 'visible',
                                    request: 'pageview'
                                }
                            }
                        })
                    }}
                />
            </amp-analytics>
            <amp-analytics type='chartbeat'>
                <script
                    type='application/json'
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify({
                            vars: {
                                uid: '66936',
                                domain: '3cat.cat',
                                sections: digitalData.page.seccio,
                                authors: digitalData.page.autor
                            }
                        })
                    }}
                ></script>
            </amp-analytics>
        </>
    );
}
